import { defineMessages } from 'react-intl';

export default defineMessages({
	invalidLogin: {
		defaultMessage: 'Something went wrong while trying to log you in. Try again.',
		description:
			'Message to show that email or password are incorrect and that the user should try again.',
		id: 'sd.login.error.invalid.login.unified',
	},
	accountLocked: {
		defaultMessage:
			"For security reasons, we've temporarily locked this account due to multiple unsuccessful login attempts. To regain access, select {forgotPasswordLink} to reset your password.",
		description: 'Error message if the account is locked.',
		id: 'sd.login.account.locked.unified',
	},
	miscLoginError: {
		defaultMessage: 'Something went wrong while trying to log you in. Try again.',
		description: 'Error message for any not classified errors.',
		id: 'sd.login.error.misc.unified',
	},
});
